
import { sortByDescending, truncate, sumBy, length, choose, fold, singleton, cons, head, tail, isEmpty, empty, tryFind, filter, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { compareArrays, curry2, equals, compare, comparePrimitives, Exception } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { SimGraph_empty, SimGraph_map, SimGraph_values, SimGraph_tryFind, SimulationComponent, SimGraph_add, SimGraph_fold, SimulationError, SimulationErrorType } from "./SimGraphTypes.js";
import { Result_MapError, Result_Bind, Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { isEmpty as isEmpty_1, map as map_1, filter as filter_1, fold as fold_1, toList, tryFind as tryFind_1, add, empty as empty_1, ofList, FSharpMap__Add, FSharpMap__TryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { union_type, list_type, class_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { empty as empty_2, FSharpSet__Add, FSharpSet__Contains } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { concat, interpolate, join, toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { runCanvasStateChecksAndBuildGraph } from "./GraphBuilder.js";
import { SimulationBudget_formatBytes, SimulationBudget_maxHeapBytes, SimulationBudget_heapBytesPerComponent } from "./SimTypes.js";
import { renderParamExpression, ParamExpression, bindingsOf, evaluateParamExpression } from "../Common/ParameterTypes.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { tryPick } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { Component, ComponentType, CustomComponentType } from "../Common/CommonTypes.js";
import { setSlotValue } from "../Common/ComponentSlots.js";

function getComponentDependencies(state_, state__1) {
    return map((comp_1) => {
        const matchValue_1 = comp_1.Type;
        if (matchValue_1.tag === 26) {
            return matchValue_1.fields[0].Name;
        }
        else {
            throw new Exception("what? Impossible, getComponentDependency");
        }
    }, filter((comp) => {
        if (comp.Type.tag === 26) {
            return true;
        }
        else {
            return false;
        }
    }, state_));
}

function getDependencyState(name, dependencies) {
    const _arg = tryFind((dep) => (dep.Name === name), dependencies);
    if (_arg == null) {
        return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* DependencyNotFound */ 16, [name]), undefined, empty(), empty())]);
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [_arg.CanvasState]);
    }
}

function buildDependencyGraph(componentName, state_, state__1, dependencies, dependencyGraph) {
    const state = [state_, state__1];
    const iterateChildren = (children_mut, dependencyGraph_1_mut) => {
        iterateChildren:
        while (true) {
            const children = children_mut, dependencyGraph_1 = dependencyGraph_1_mut;
            if (!isEmpty(children)) {
                const children$0027 = tail(children);
                const child = head(children);
                const matchValue = FSharpMap__TryFind(dependencyGraph_1, child);
                if (matchValue == null) {
                    const matchValue_1 = getDependencyState(child, dependencies);
                    if (matchValue_1.tag === 0) {
                        const childState = matchValue_1.fields[0];
                        const matchValue_2 = buildDependencyGraph(child, childState[0], childState[1], dependencies, dependencyGraph_1);
                        if (matchValue_2.tag === 0) {
                            children_mut = children$0027;
                            dependencyGraph_1_mut = matchValue_2.fields[0];
                            continue iterateChildren;
                        }
                        else {
                            return new FSharpResult$2(/* Error */ 1, [matchValue_2.fields[0]]);
                        }
                    }
                    else {
                        const err = matchValue_1.fields[0];
                        return new FSharpResult$2(/* Error */ 1, [new SimulationError(err.ErrType, componentName, err.ComponentsAffected, err.ConnectionsAffected)]);
                    }
                }
                else {
                    children_mut = children$0027;
                    dependencyGraph_1_mut = dependencyGraph_1;
                    continue iterateChildren;
                }
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [dependencyGraph_1]);
            }
            break;
        }
    };
    const children_1 = getComponentDependencies(state[0], state[1]);
    return iterateChildren(children_1, FSharpMap__Add(dependencyGraph, componentName, children_1));
}

class DfsType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoCycle", "Backtracking", "Cycle"];
    }
}

function DfsType_$reflection() {
    return union_type("GraphMerger.DfsType", [], DfsType, () => [[["Item", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]], [["Item1", list_type(string_type)], ["Item2", string_type]], [["Item", list_type(string_type)]]]);
}

function checkDependencyCycle(currNode, depGraph, visited, currStack) {
    let matchValue_5;
    const exploreChildren = (visited_1_mut, currStack_1_mut, children_mut) => {
        exploreChildren:
        while (true) {
            const visited_1 = visited_1_mut, currStack_1 = currStack_1_mut, children = children_mut;
            if (!isEmpty(children)) {
                const matchValue = checkDependencyCycle(head(children), depGraph, visited_1, currStack_1);
                switch (matchValue.tag) {
                    case 1: {
                        const cycleEnd = matchValue.fields[1];
                        const cycle = matchValue.fields[0];
                        if (cycleEnd === currNode) {
                            return new DfsType(/* Cycle */ 2, [cons(currNode, cycle)]);
                        }
                        else {
                            return new DfsType(/* Backtracking */ 1, [cons(currNode, cycle), cycleEnd]);
                        }
                    }
                    case 2:
                        return new DfsType(/* Cycle */ 2, [matchValue.fields[0]]);
                    default: {
                        visited_1_mut = matchValue.fields[0];
                        currStack_1_mut = currStack_1;
                        children_mut = tail(children);
                        continue exploreChildren;
                    }
                }
            }
            else {
                return new DfsType(/* NoCycle */ 0, [visited_1]);
            }
            break;
        }
    };
    const matchValue_2 = FSharpSet__Contains(currStack, currNode);
    const matchValue_3 = FSharpSet__Contains(visited, currNode);
    if (matchValue_2) {
        if (matchValue_3) {
            return new DfsType(/* Backtracking */ 1, [singleton(currNode), currNode]);
        }
        else {
            return toFail(printf("what? Node never visited but in the stack, while detecting cycle: %s"))(currNode);
        }
    }
    else if (matchValue_3) {
        return new DfsType(/* NoCycle */ 0, [visited]);
    }
    else {
        return exploreChildren(FSharpSet__Add(visited, currNode), FSharpSet__Add(currStack, currNode), (matchValue_5 = FSharpMap__TryFind(depGraph, currNode), (matchValue_5 != null) ? matchValue_5 : toFail(printf("what? Could not find dependency %s in cycle detection"))(currNode)));
    }
}

function buildDependencyMap(loadedDependencies) {
    const dependenciesRes = map((dep) => {
        let tupledArg;
        return [dep.Name, (tupledArg = dep.CanvasState, runCanvasStateChecksAndBuildGraph(tupledArg[0], tupledArg[1], loadedDependencies))];
    }, loadedDependencies);
    const matchValue = tryFind((tupledArg_1) => {
        if (tupledArg_1[1].tag === 0) {
            return false;
        }
        else {
            return true;
        }
    }, dependenciesRes);
    if (matchValue == null) {
        return new FSharpResult$2(/* Ok */ 0, [ofList(map((tupledArg_2) => {
            const name_1 = tupledArg_2[0];
            const res_1 = tupledArg_2[1];
            if (res_1.tag === 1) {
                return toFail(printf("what? Dependency %s expected to be Ok, but has error %A"))(name_1)(res_1.fields[0]);
            }
            else {
                return [name_1, res_1.fields[0]];
            }
        }, dependenciesRes), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })]);
    }
    else {
        const copyOfStruct = matchValue[1];
        if (copyOfStruct.tag === 1) {
            const name_2 = matchValue[0];
            return new FSharpResult$2(/* Error */ 1, [new SimulationError(copyOfStruct.fields[0].ErrType, name_2, empty(), empty())]);
        }
        else {
            throw new Exception("what? Impossible case in buildDependencyMap");
        }
    }
}

function checkDependenciesAndBuildMap(currDiagramName, state_, state__1, dependencies) {
    let arg;
    const state = [state_, state__1];
    const prettyPrintCycle = (cycle) => {
        if (!isEmpty(cycle)) {
            if (isEmpty(tail(cycle))) {
                return ("\"" + head(cycle)) + "\"";
            }
            else {
                return (("\"" + head(cycle)) + "\" --> ") + prettyPrintCycle(tail(cycle));
            }
        }
        else {
            return "";
        }
    };
    const matchValue = buildDependencyGraph(currDiagramName, state[0], state[1], dependencies, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
    if (matchValue.tag === 0) {
        const matchValue_1 = checkDependencyCycle(currDiagramName, matchValue.fields[0], empty_2({
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), empty_2({
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }));
        switch (matchValue_1.tag) {
            case 2:
                return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* CycleDetected */ 14, [(arg = prettyPrintCycle(matchValue_1.fields[0]), toText(printf("Found a cycle in dependencies: %s."))(arg))]), undefined, empty(), empty())]);
            case 0:
                return buildDependencyMap(filter((dep) => FSharpSet__Contains(matchValue_1.fields[0], dep.Name), dependencies));
            default:
                throw new Exception("what? checkDependencyCycle finished while Backtracking");
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]);
    }
}

function expandedSizes(topSheet, state_, state__1, ldcs) {
    const canvasOf = add(topSheet, [state_, state__1], ofList(map((ldc) => [ldc.Name, ldc.CanvasState], ldcs), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
    const sizeOf = (memo, sheet_2) => {
        let matchValue;
        const matchValue_3 = tryFind_1(sheet_2, memo);
        if (matchValue_3 == null) {
            const patternInput_1 = fold((tupledArg, child) => {
                const _arg = tupledArg[0];
                const patternInput = sizeOf(tupledArg[1], child);
                return [[_arg[0] + patternInput[0][0], _arg[1] + patternInput[0][1]], patternInput[1]];
            }, [[0, 0], memo], (matchValue = tryFind_1(sheet_2, canvasOf), (matchValue != null) ? choose((comp) => {
                const matchValue_1 = comp.Type;
                if (matchValue_1.tag === 26) {
                    return matchValue_1.fields[0].Name;
                }
                else {
                    return undefined;
                }
            }, matchValue[0]) : empty()));
            let patternInput_2;
            const matchValue_2 = tryFind_1(sheet_2, canvasOf);
            if (matchValue_2 != null) {
                const comps_1 = matchValue_2[0];
                patternInput_2 = [length(comps_1), sumBy((c) => (length(c.InputPorts) + length(c.OutputPorts)), comps_1, {
                    GetZero: () => 0,
                    Add: (x_1, y_1) => (x_1 + y_1),
                })];
            }
            else {
                patternInput_2 = [0, 0];
            }
            const size_1 = [patternInput_2[0] + patternInput_1[0][0], patternInput_2[1] + patternInput_1[0][1]];
            return [size_1, add(sheet_2, size_1, patternInput_1[1])];
        }
        else {
            return [matchValue_3, memo];
        }
    };
    return sizeOf(empty_1({
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), topSheet);
}

/**
 * How many SimulationComponents the merged graph will hold, and how many ports they have between
 * them - which is what says what they will cost.
 */
export function expandedSize(topSheet, state_, state__1, ldcs) {
    const state = [state_, state__1];
    return expandedSizes(topSheet, state[0], state[1], ldcs)[0];
}

/**
 * How many SimulationComponents the merged graph will hold.
 */
export function expandedComponentCount(topSheet, state_, state__1, ldcs) {
    const state = [state_, state__1];
    return expandedSize(topSheet, state[0], state[1], ldcs)[0];
}

/**
 * What the expanded design will cost in heap, by the same reckoning checkExpansionFits refuses on.
 * Costs a walk of each sheet's canvas and never of the expansion, so it is cheap enough to ask
 * before every simulation - which the waveform simulator does, to decide how many clock cycles to
 * start with rather than only whether to start at all.
 */
export function expandedHeapEstimate(topSheet, state_, state__1, ldcs) {
    const state = [state_, state__1];
    const patternInput = expandedSize(topSheet, state[0], state[1], ldcs);
    const components = patternInput[0];
    return components * SimulationBudget_heapBytesPerComponent((components > 0) ? (patternInput[1] / components) : 0);
}

function biggestContributors(topSheet, state_, state__1, ldcs) {
    const state = [state_, state__1];
    return map((tuple_3) => tuple_3[0], truncate(3, sortByDescending((arg) => arg[1][0], filter((tupledArg) => (tupledArg[0] !== topSheet), toList(expandedSizes(topSheet, state[0], state[1], ldcs)[1])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })));
}

/**
 * Refuse a design whose expanded graph will not fit in memory, before any of it is built.
 */
export function checkExpansionFits(topSheet, state_, state__1, ldcs) {
    const state = [state_, state__1];
    const patternInput = expandedSize(topSheet, state[0], state[1], ldcs);
    const components = patternInput[0];
    const portsEach = (components > 0) ? (patternInput[1] / components) : 0;
    const needed = expandedHeapEstimate(topSheet, state[0], state[1], ldcs);
    if (needed <= SimulationBudget_maxHeapBytes()) {
        return new FSharpResult$2(/* Ok */ 0, [undefined]);
    }
    else {
        const fits = SimulationBudget_maxHeapBytes() / SimulationBudget_heapBytesPerComponent(portsEach);
        const worst = join(", ", biggestContributors(topSheet, state[0], state[1], ldcs));
        return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [`Simulating this design means expanding every sheet into every place it is used, which comes to ${interpolate("%.0f%P()", [components])} components needing ${SimulationBudget_formatBytes(needed)} - more than the ${SimulationBudget_formatBytes(SimulationBudget_maxHeapBytes())} Issie will use for it, and more than the ${interpolate("%.0f%P()", [fits])} components that would fit. This grows by multiplication rather than addition: a sheet used four times, each of whose four instances uses another sheet four times, is sixteen copies of the innermost sheet. Most of the size here is in ${worst}. Simulate one subsheet on its own, or reduce how many times the sheets below it are instantiated.`]), undefined, empty(), empty())]);
    }
}

function merger(currGraph, dependencyMap, loadedDependencies) {
    return SimGraph_fold((currGraph_1, compId, comp) => {
        let matchValue_1;
        const matchValue = comp.Type;
        if (matchValue.tag === 26) {
            const custom = matchValue.fields[0];
            return SimGraph_add(compId, new SimulationComponent(comp.Id, comp.Type, comp.Label, comp.Outputs, comp.DrivenInputWidths, comp.InputWidths, comp.OutputWidths, merger((matchValue_1 = FSharpMap__TryFind(dependencyMap, custom.Name), (matchValue_1 != null) ? matchValue_1 : toFail(printf("what? Could not find dependency %s in dependencyMap"))(custom.Name)), dependencyMap, loadedDependencies)), currGraph_1);
        }
        else {
            return currGraph_1;
        }
    }, currGraph, currGraph);
}

function evaluateAllBindings(bindings) {
    return fold_1((values, name, expr) => {
        const option_1 = values;
        if (option_1 != null) {
            const values_1 = option_1;
            const matchValue = evaluateParamExpression(bindings, expr);
            if (matchValue.tag === 1) {
                return undefined;
            }
            else {
                return add(name, matchValue.fields[0], values_1);
            }
        }
        else {
            return undefined;
        }
    }, empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), bindings);
}

function bindingDiff(defaults, effective) {
    const matchValue = evaluateAllBindings(defaults);
    const matchValue_1 = evaluateAllBindings(effective);
    let matchResult, defaultValues, effectiveValues;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            defaultValues = matchValue;
            effectiveValues = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return filter_1((name, value) => !equals(tryFind_1(name, defaultValues), value), effectiveValues);
        default:
            return undefined;
    }
}

function defaultBindingsOfSheet(loadedDependencies, sheetName) {
    let option_3, option_1;
    return defaultArg((option_3 = ((option_1 = tryFind((lc) => (lc.Name === sheetName), loadedDependencies), (option_1 != null) ? option_1.LCParameterSlots : undefined)), (option_3 != null) ? bindingsOf(option_3.DefaultBindings) : undefined), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
}

function effectiveBindings(defaults, instance) {
    if (instance != null) {
        const given = instance;
        return map_1((name, expr) => defaultArg(tryFind_1(name, given), expr), defaults);
    }
    else {
        return defaults;
    }
}

function resolveSheet(memo, bindings, currDiagramName, loadedDependencies, graph) {
    let option_3, option_1;
    const paramSlots = defaultArg((option_3 = ((option_1 = tryFind((lc) => (lc.Name === currDiagramName), loadedDependencies), (option_1 != null) ? option_1.LCParameterSlots : undefined)), (option_3 != null) ? option_3.ParamSlots : undefined), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const evalExpr = (expr) => evaluateParamExpression(bindings, expr);
    const diffOpt = bindingDiff(defaultBindingsOfSheet(loadedDependencies, currDiagramName), bindings);
    let matchValue_17;
    const option_7 = diffOpt;
    matchValue_17 = ((option_7 != null) ? tryFind_1([currDiagramName, option_7], memo) : undefined);
    if (matchValue_17 == null) {
        return Result_Map((tupledArg_5) => {
            const resolved_4 = tupledArg_5[0];
            const memo$0027_3 = tupledArg_5[1];
            if (diffOpt == null) {
                return [resolved_4, memo$0027_3];
            }
            else {
                return [resolved_4, add([currDiagramName, diffOpt], resolved_4, memo$0027_3)];
            }
        }, Result_Bind((tupledArg_4) => {
            let resolved_1, matchValue_7, patternInput, substituted;
            const resolved_3 = tupledArg_4[0];
            const memo$0027_2 = tupledArg_4[1];
            if (isEmpty_1(paramSlots) ? true : equals(diffOpt, empty_1({
                Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
            }))) {
                return new FSharpResult$2(/* Ok */ 0, [[resolved_3, memo$0027_2]]);
            }
            else {
                return Result_Map((rebuilt) => [rebuilt, memo$0027_2], (resolved_1 = resolved_3, (matchValue_7 = tryFind((lc_2) => (lc_2.Name === currDiagramName), loadedDependencies), (matchValue_7 != null) ? ((patternInput = matchValue_7.CanvasState, (substituted = [map((comp_3) => {
                    let comp_2, matchValue_8, sc, matchValue_9, matchValue_10, cGraph_2, portWidth;
                    return new Component(comp_3.Id, (comp_2 = comp_3, (matchValue_8 = SimGraph_tryFind(comp_2.Id, resolved_1), (matchValue_8 != null) ? ((sc = matchValue_8, (matchValue_9 = sc.Type, (matchValue_10 = sc.CustomSimulationGraph, (matchValue_9.tag === 26) ? ((matchValue_10 != null) ? ((cGraph_2 = matchValue_10, (portWidth = ((isOutput, _arg_1) => {
                        const label = _arg_1[0];
                        return [label, defaultArg(tryPick((child) => {
                            const matchValue_12 = child.Label;
                            const matchValue_13 = child.Type;
                            let matchResult, l_2, w_2, l_3, w_3;
                            switch (matchValue_13.tag) {
                                case 1: {
                                    if (isOutput) {
                                        if (matchValue_12 === label) {
                                            matchResult = 0;
                                            l_2 = matchValue_12;
                                            w_2 = matchValue_13.fields[0];
                                        }
                                        else {
                                            matchResult = 2;
                                        }
                                    }
                                    else {
                                        matchResult = 2;
                                    }
                                    break;
                                }
                                case 0: {
                                    if (isOutput) {
                                        matchResult = 2;
                                    }
                                    else if (matchValue_12 === label) {
                                        matchResult = 1;
                                        l_3 = matchValue_12;
                                        w_3 = matchValue_13.fields[0];
                                    }
                                    else {
                                        matchResult = 2;
                                    }
                                    break;
                                }
                                default:
                                    matchResult = 2;
                            }
                            switch (matchResult) {
                                case 0:
                                    return w_2;
                                case 1:
                                    return w_3;
                                default:
                                    return undefined;
                            }
                        }, SimGraph_values(cGraph_2)), _arg_1[1])];
                    }), new ComponentType(/* Custom */ 26, [new CustomComponentType(matchValue_9.fields[0].Name, map(curry2(portWidth)(false), matchValue_9.fields[0].InputLabels), map(curry2(portWidth)(true), matchValue_9.fields[0].OutputLabels), matchValue_9.fields[0].Form, matchValue_9.fields[0].ParameterBindings, matchValue_9.fields[0].Description)])))) : matchValue_9) : matchValue_9)))) : comp_2.Type)), comp_3.Label, comp_3.InputPorts, comp_3.OutputPorts, comp_3.X, comp_3.Y, comp_3.H, comp_3.W, comp_3.SymbolInfo, comp_3.SlotInfo);
                }, patternInput[0]), patternInput[1]], Result_MapError((e) => {
                    if (e.InDependency == null) {
                        return new SimulationError(e.ErrType, currDiagramName, e.ComponentsAffected, e.ConnectionsAffected);
                    }
                    else {
                        return e;
                    }
                }, Result_Map((fresh) => SimGraph_map((cid, freshComp) => {
                    const matchValue_15 = SimGraph_tryFind(cid, resolved_1);
                    if (matchValue_15 == null) {
                        return freshComp;
                    }
                    else {
                        return new SimulationComponent(freshComp.Id, freshComp.Type, freshComp.Label, freshComp.Outputs, freshComp.DrivenInputWidths, freshComp.InputWidths, freshComp.OutputWidths, matchValue_15.CustomSimulationGraph);
                    }
                }, fresh), runCanvasStateChecksAndBuildGraph(substituted[0], substituted[1], loadedDependencies)))))) : (new FSharpResult$2(/* Ok */ 0, [resolved_1])))));
            }
        }, SimGraph_fold((acc_1, compId_2, comp_1) => Result_Bind((tupledArg_2) => {
            let compId;
            const memo_3 = tupledArg_2[1];
            return Result_Map((tupledArg_3) => [SimGraph_add(compId_2, tupledArg_3[0], tupledArg_2[0]), tupledArg_3[1]], Result_Bind((c_2) => {
                let matchValue_2, instanceBindings;
                const matchValue_4 = c_2.Type;
                const matchValue_5 = c_2.CustomSimulationGraph;
                let matchResult_1, cGraph_1, cc_1;
                if (matchValue_4.tag === 26) {
                    if (matchValue_5 != null) {
                        matchResult_1 = 0;
                        cGraph_1 = matchValue_5;
                        cc_1 = matchValue_4.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const compId_1 = compId_2;
                        const c_1 = c_2;
                        const cc = cc_1;
                        const matchValue_1 = tryFind((lc_1) => (lc_1.Name === cc.Name), loadedDependencies);
                        if (matchValue_1 != null) {
                            return Result_Bind((instanceBindings_1) => {
                                const bindings_1 = effectiveBindings(defaultBindingsOfSheet(loadedDependencies, cc.Name), instanceBindings_1);
                                return Result_Map((tupledArg_1) => [new SimulationComponent(c_1.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(cc.Name, cc.InputLabels, cc.OutputLabels, cc.Form, bindings_1, cc.Description)]), c_1.Label, c_1.Outputs, c_1.DrivenInputWidths, c_1.InputWidths, c_1.OutputWidths, tupledArg_1[0]), tupledArg_1[1]], resolveSheet(memo_3, bindings_1, cc.Name, loadedDependencies, cGraph_1));
                            }, (matchValue_2 = cc.ParameterBindings, (matchValue_2 != null) ? ((instanceBindings = matchValue_2, Result_Map((Value) => Value, fold_1((acc, name, expr_2) => Result_Bind((evaluated) => {
                                const matchValue_3 = evalExpr(expr_2);
                                if (matchValue_3.tag === 1) {
                                    return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [`Parameter '${name.fields[0]}' of ${cc.Name} could not be evaluated. ${matchValue_3.fields[0]}`]), currDiagramName, singleton(compId_1), empty())]);
                                }
                                else {
                                    return new FSharpResult$2(/* Ok */ 0, [add(name, new ParamExpression(/* PInt */ 0, [matchValue_3.fields[0]]), evaluated)]);
                                }
                            }, acc), new FSharpResult$2(/* Ok */ 0, [empty_1({
                                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
                            })]), instanceBindings)))) : (new FSharpResult$2(/* Ok */ 0, [undefined]))));
                        }
                        else {
                            return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* DependencyNotFound */ 16, [cc.Name]), currDiagramName, singleton(compId_1), empty())]);
                        }
                    }
                    default:
                        return new FSharpResult$2(/* Ok */ 0, [[c_2, memo_3]]);
                }
            }, (compId = compId_2, fold((compRes, tupledArg) => {
                const expr_1 = tupledArg[1];
                return Result_Bind((c) => {
                    const matchValue = evalExpr(expr_1.Expression);
                    if (matchValue.tag === 1) {
                        return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [concat("Parameter expression \'", renderParamExpression(expr_1.Expression, 0), "\' could not be evaluated. ", matchValue.fields[0])]), currDiagramName, singleton(compId), empty())]);
                    }
                    else {
                        return new FSharpResult$2(/* Ok */ 0, [new SimulationComponent(c.Id, setSlotValue(tupledArg[0].CompSlot, matchValue.fields[0], c.Type), c.Label, c.Outputs, c.DrivenInputWidths, c.InputWidths, c.OutputWidths, c.CustomSimulationGraph)]);
                    }
                }, compRes);
            }, new FSharpResult$2(/* Ok */ 0, [comp_1]), toList(filter_1((slot, _arg) => equals(slot.CompId, compId), paramSlots))))));
        }, acc_1), new FSharpResult$2(/* Ok */ 0, [[SimGraph_empty, memo]]), graph)));
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [[matchValue_17, memo]]);
    }
}

/**
 * Resolve every parameterised slot in a sheet and, recursively, in the sheets of the custom
 * components it contains. `state` is unused: the slots come from the LoadedComponent.
 */
export function resolveParametersInSimulationGraph(bindings, currDiagramName, state_, state__1, loadedDependencies, graph) {
    return Result_Map((tuple) => tuple[0], resolveSheet(empty_1({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), bindings, currDiagramName, loadedDependencies, graph));
}

/**
 * Try to resolve all the dependencies in a graph, and replace the reducer
 * of the custom components with a simulationgraph.
 * <summary>
 * Merges dependencies into the simulation graph and resolves all parameters.
 * </summary>
 * <param name="currDiagramName">The name of the current sheet being processed</param>
 * <param name="graph">The initial simulation graph to merge dependencies into</param>
 * <param name="state">The current canvas state</param>
 * <param name="loadedDependencies">List of all loaded component sheets</param>
 * <returns>
 * Success: A fully merged and parameterized simulation graph
 * Error: Details of any dependency or parameter resolution failures
 * </returns>
 * <remarks>
 * Parameter Resolution:
 * 
 * Stage 1 - Merging (via merger function):
 * - Custom components are replaced with their internal graphs
 * - Parameter resolution is DEFERRED to avoid forward reference issues
 * - Each custom component's graph is stored in CustomSimulationGraph field
 * 
 * Stage 2 - Parameter Resolution (resolveParametersInSimulationGraph, after all merging):
 * - The top sheet is resolved with its own default bindings
 * - Each sheet below is resolved with the bindings of the instance containing it, so instance
 * bindings override defaults
 * - Sheets whose bindings give the same difference from their defaults are resolved once
 * 
 * </remarks>
 */
export function mergeDependencies(currDiagramName, graph, state_, state__1, loadedDependencies) {
    let matchValue;
    const state = [state_, state__1];
    return Result_Bind((graph_1) => resolveParametersInSimulationGraph(defaultBindingsOfSheet(loadedDependencies, currDiagramName), currDiagramName, state[0], state[1], loadedDependencies, graph_1), (matchValue = checkDependenciesAndBuildMap(currDiagramName, state[0], state[1], loadedDependencies), (matchValue.tag === 0) ? Result_Map(() => merger(graph, matchValue.fields[0], loadedDependencies), checkExpansionFits(currDiagramName, state[0], state[1], loadedDependencies)) : (new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]))));
}

